import { defineMeta } from '@/registry/types';

export const alertsExampleMeta = defineMeta({
  name: 'AlertsExample',
  level: 'page',
  category: 'example',
  classification: 'custom',
  description: 'Reference alerts feed page using the Alert molecule.',
  baseLibrary: 'custom',
  importPath: '@/pages/AlertsExample',
  supportedStates: ['default'],
  designTokens: ['colors'],
  usageExamples: ['<AlertsExample />'],
  llmSafe: false,
  whenToUse: ['Reference for alert/notification feeds'],
  whenNotToUse: ['Production without data wiring'],
});

export default alertsExampleMeta;
